import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { makeGetActiveProjects } from 'selectors/projects';

import ResourceSelector from 'components/ResourceSelector';

const ProjectSelector = ({ projects, excluded, selected, onSelect }) => {
    const availableProjects = useMemo(() => {
        if (excluded.length) {
            return projects.filter(({ id }) => !excluded.includes(id));
        }

        return projects;
    }, [projects, excluded]);

    return (
        <ResourceSelector
            withSearch={true}
            searchPlaceholder="Search projects…"
            emptyText="No Projects available."
            items={availableProjects.map(project => ({
                id: project.id,
                title: project.name
            }))}
            selected={selected}
            onSelect={onSelect}
        />
    );
}

ProjectSelector.defaultProps = {
    excluded: []
}

const makeMapStateToProps = () => {
    const getActiveProjects = makeGetActiveProjects();

    return ({ projects }) => ({
        projects: getActiveProjects(projects.items)
    });
}

export default connect(makeMapStateToProps)(ProjectSelector);
